import { OnInit, Component, Inject } from '@angular/core';
import { Utility } from '../../../common/utility';
import { BaseService } from '../../../shared/services/base.service';
import { DialogService } from '../../../shared/services/dialog.service';
import { FormBuilder, Validators } from '@angular/forms';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { FormGroup } from '@angular/forms';
import { ValidationService } from '../../../shared/services/validation.service';
import { AppMessages } from '../../../shared/constants/messages';
import { ManageVaccineService } from './manage-vaccine.service';

@Component({
  selector: 'manage-vaccine-add-popup',
  templateUrl: 'manage-vaccine-add-popup.component.html',
  providers: [ManageVaccineService, ValidationService]
})
export class ManageVaccineAddPopupComponent implements OnInit {
  addVaccineForm: FormGroup;
  vaccineList: Array<any>;
  saved = false;
  objArray: Array<any>;
  isSaveAndAddOther = true;
  constructor(
    public utility: Utility,
    public baseService: BaseService,
    public dialogService: DialogService,
    private formBuilder: FormBuilder,
    public dialogRef: MdDialogRef<ManageVaccineAddPopupComponent>,
    public vaccineService: ManageVaccineService,
    @Inject(MD_DIALOG_DATA) public data = { vaccineId: null, centreId: null, saveAndAddOther: true },
  ) {
    this.createForm();
    this.setForm();
  }

  ngOnInit() {
    if (this.data) {
      this.isSaveAndAddOther = (this.data.saveAndAddOther !== undefined || this.data.saveAndAddOther !== null) ?
        this.data.saveAndAddOther : true;
    }
    this.getVaccineList(this.isSaveAndAddOther);
    this.objArray = new Array();
  }

  createForm() {
    const date = new Date();
    const minDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1, 0, 0, 0);
    this.addVaccineForm = this.formBuilder.group({
      vaccineId: ['', [Validators.required]],
      batchNumber: ['', [Validators.required]],
      expiredDate: [null, [Validators.required, ValidationService.validateMinDate(minDate,
        AppMessages.vaccine.minDate)]],
      quantity: ['', [Validators.required, ValidationService.isValidNumberFromTo(1, 2000)]],
      centreId: [null]
    });
  }

  setForm() {
    if (this.data) {
      this.addVaccineForm.controls.vaccineId.setValue(this.data.vaccineId);
      this.addVaccineForm.controls.centreId.setValue(this.data.centreId);
    }
  }

  setResetForm() {
    if (this.addVaccineForm.controls) {
      for (const name in this.addVaccineForm.controls) {
        if (this.addVaccineForm.controls.hasOwnProperty(name)) {
          if (name !== 'vaccineId') {
            this.addVaccineForm.controls[name].setValue(null);
          }
        }
      }
    }
    this.setForm();

  }

  getVaccineList(isSaveAndAddOther = true) {
    this.vaccineService.getCentreVaccine(this.data.centreId, !isSaveAndAddOther).subscribe(result => {
      if (result) {
        const data = result.json();
        this.vaccineList = data;
        if (isSaveAndAddOther === false) {
          if (this.vaccineList) {
            this.addVaccineForm.controls['vaccineId'].setValue(this.vaccineList.find(ele => ele.value === this.data.vaccineId).id);
          }
        }
      }
    });
  }

  onSubmit(isClose = false) {
    this.markAsTouch();
    if (this.addVaccineForm.valid && this.addVaccineForm.dirty) {
      const formValue = this.addVaccineForm.value;
      formValue.expiredDate = this.utility.convertDateToString(formValue.expiredDate);
      this.vaccineService.addNewVaccineBatch(formValue).subscribe(
        result => {
          if (result) {
            const data = result.json();
            this.dialogService.openSuccessDialog({ message: data['message'] })
            this.saved = true;
            if (this.isSaveAndAddOther) {
              this.onCloseDialog(this.saved);
            } else {
              const batchObj = {
                vaccineId: this.vaccineList.find(x => x.id === this.addVaccineForm.controls.vaccineId.value).value,
                batch: {
                  id: this.addVaccineForm.controls.batchNumber.value,
                  code: null,
                  name: this.addVaccineForm.controls.batchNumber.value,
                  value: null,
                  isSelected: false,
                  isActive: false
                }
              };
              this.dialogRef.close(batchObj);
            }
          }
        }
      );

    }
  }

  saveAndAddOther() {
    this.markAsTouch();
    if (this.addVaccineForm.valid && this.addVaccineForm.dirty) {
      const formValue = this.addVaccineForm.value;
      formValue.expiredDate = this.utility.convertDateToString(formValue.expiredDate);
      this.vaccineService.addNewVaccineBatch(formValue).subscribe(
        result => {
          if (result) {
            const data = result.json();
            this.saved = true;
            this.setResetForm();
          }
        }
      );
    }
  }

  markAsTouch() {
    for (const key in this.addVaccineForm.controls) {
      if (this.addVaccineForm.controls.hasOwnProperty(key)) {
        this.addVaccineForm.controls[key].markAsTouched();
        this.addVaccineForm.controls[key].updateValueAndValidity();
      }
    }
  }

  onCloseDialog(isSaved = false) {
    this.dialogRef.close(isSaved);
  }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/centre/manage-vaccine/manage-vaccine-add-popup.component.ts